export enum CREDENTIAL_ROUTE_NAMES {
  CREDENTIAL_INDEX = "credential-index",
  CREDENTIAL_USERPASS_NEW = "userpass-new",
  CREDENTIAL_ACCESS_KEY_NEW = "access-key-new",
  CREDENTIAL_DOCKER_REGISTRY_NEW = "docker-registry-new",
  CREDENTIAL_GENERIC_SECRET_NEW = "generic-secret-new",
}
